import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom'; // Import BrowserRouter from react-router-dom
import App from './App';
import './index.css';

// Suppress the benign "ResizeObserver loop completed with undelivered notifications"
// warning which is a non-fatal browser quirk, not a real application error.
// Must use capture phase (true) to fire BEFORE React's internal handleError.
const resizeObserverErr = /ResizeObserver loop/;
window.addEventListener('error', (event) => {
  if (resizeObserverErr.test(event.message)) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
}, true);

ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById('root')
);
